module.exports = __webpack_public_path__ + "static/img/OIP4.68f1588.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/OIP4.webp
// module id = jt4f
// module chunks = 0